import Diplom from "./Diplom";
import TitleDiplom from "./TitleDiplom";

export default function Diploms() {
    return (

        <section className="diploms">
            <TitleDiplom />
            <article>
                <Diplom date="2022/2024" nomDip="Diplôme en Développement Digital - Option Full Stack" desDip="Institut des Technologies Appliquées - AHFIR" icon='fa-solid fa-briefcase' />
                <Diplom date="2021/2022" nomDip="Baccalauréat Libre" desDip="Sciences et Technologies Mécaniques - BERKANE" icon='fa-solid fa-briefcase' />
                <Diplom date="2020/2021" nomDip="Certificat en Développement Web et Mobile" desDip="Propulsé par Simplon ― Programme Aljisr Greenchip2.0 - Association BERKANE" icon='fa-solid fa-briefcase' />
                {/* <Diplom date="Mars 2021" nomDip="Certificat de l'Association AlJisr Partenariat École-Entreprise" desDip="Formation en Soft Skills et Nouvelles Technologies Numériques - BERKANE" icon='fa-solid fa-briefcase' /> */}
                <Diplom date="2019/2020" nomDip="Baccalauréat" desDip="Série Lettres et Sciences Humaines - MOULOUYA BERKANE" icon='fa-solid fa-briefcase' />
            </article>
        </section>
    );
}